<template>
  <div id="app">
    <!-- <v-app id='inspire'> -->
    <!-- v-app-bar -->
    <v-app-bar app color="#27AB9C" elevate-on-scroll elevation="1" style="z-index: 12 !important;">
      <!-- nav icon app -->
      <!-- <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="hidden-md-and-up" v-if="MobileSize"></v-app-bar-nav-icon> -->
      <!-- Toolbar App -->
      <v-toolbar-title class="hidden-md-and-up" style="padding-botton: 20px;">
        <v-img src="https://s3gw.inet.co.th:8082/e-pro-uat/img/panit_logo.png" contain :width="MobileSize ? 82 : IpadSize || IpadProSize ? 47 : 57" :height="MobileSize ? 82 : IpadSize || IpadProSize ? 47 : 57"
          style="cursor: pointer; float: right;" @click="goHome()" />
      </v-toolbar-title>
      <div v-if="MobileSize && !IpadSize" class="pl-2" style="width: 100%;">
        <v-text-field color="#27AB9C" v-model="searchtext" placeholder="ค้นหาสินค้าและร้านค้า" dense outlined hide-details
          @keyup.enter="searchdata()" class="textSearch" style="background: #FFFFFF; width: 100%;">
          <v-icon slot="append" @click="searchdata()" color="#27AB9C" class="padding-left:40%">mdi-magnify </v-icon>
        </v-text-field>
      </div>
      <div v-else-if="!MobileSize && IpadSize" class="pl-2" :style="statusLogin === false ? 'width: 430px;' :'width: 450px;'">
        <v-text-field color="#27AB9C" v-model="searchtext" placeholder="ค้นหาสินค้าและร้านค้า" dense outlined hide-details
          @keyup.enter="searchdata()" class="textSearchIpad" style="background: #FFFFFF;">
          <v-icon slot="append" @click="searchdata()" color="#27AB9C" style="padding-left: 0%;">mdi-magnify </v-icon>
        </v-text-field>
      </div>
      <CartPopover v-if="path && (MobileSize || IpadSize)"/>
      <Notification class="hidden-md-and-up" v-if="Notification_on_off && statusLogin === true" />
      <v-icon style="width: 38px; height: 38px;margin-left:0px" color="#FFFFFF" large
        v-if="statusLogin === false && !IpadSize" @click="modalLogin = !modalLogin" class="hidden-sm-and-up mr-8">
        mdi-account-circle-outline</v-icon>
      <!-- <v-row dense v-if="statusLogin === false && IpadSize" class="mt-0" style="width: 173px;" justify="end" no-gutters> -->
      <!-- <v-btn text style="font-weight: bold; font-size: 16px; line-height: 24px; color:  white;" @click="linkLoginandRegister('UPS/Login')" @mousedown.right="linkLoginandRegisterRightClick('UPS/Login')" :to="loginpath" v-if="statusLogin === false && IpadSize">เข้าสู่ระบบ</v-btn>
      <v-divider vertical style="color: white;" v-if="statusLogin === false && IpadSize"></v-divider>
      <v-btn text style="font-size: 16px; line-height: 24px; color:  white;" @mousedown.left="linkLoginandRegister('UPS/Register')" @mousedown.right="linkLoginandRegisterRightClick('UPS/Register')" :to="registerpath" v-if="statusLogin === false && IpadSize">สมัครสมาชิก</v-btn> -->
      <Login v-if="statusLogin === false && IpadSize" class="mt-0 mr-4" />
      <LoginSuccess v-if="(MobileSize || IpadSize) && statusLogin === true" class="mt-0" :class="MobileSize ? 'pr-0' : ''" />
      <!-- </v-row> -->
      <!-- <LoginSuccess class="hidden-md-and-up" v-if="statusLogin === true"/> -->
      <!-- toolbar Web -->
      <v-row v-if="!MobileSize && !IpadSize" no-gutters>
        <v-col cols="12">
          <v-toolbar-title>
            <v-row dense class="appBarResponsive">
              <v-col cols="12" md="1" sm="1" xs="1" class="mt-2" style="padding-right: 5px;">
                <router-link :to="{ path: pathHome }">
                  <v-img v-lazyload src="https://s3gw.inet.co.th:8082/e-pro-uat/img/panit_logo.png" contain width="100%"
                    height="60" style="cursor: pointer;" @mousedown.left="goHome()"
                    @mousedown.right="goHomeRightClick()" />
                </router-link>
              </v-col>
              <v-col cols="12" :md="IpadProSize? 6 : 7" sm="4" xs="4" class="mt-4">
                <!-- <v-toolbar-title> -->
                <v-text-field color="#FFFFFF" v-model="searchtext" placeholder="ค้นหาสินค้าและร้านค้า" dense outlined hide-details
                  @keyup.enter="searchdata()">
                  <v-icon slot="append" @click="searchdata()" color="#27AB9C">mdi-magnify </v-icon>
                </v-text-field>
                <!-- </v-toolbar-title> -->
              </v-col>
              <v-col cols="12" :md="IpadProSize? 5 : 4" sm="3" xs="3" class="pl-2">
                <v-row>
                  <v-col cols="12" md="1" class="pr-0 mt-3" v-if="IpadProSize">
                    <CartPopover v-if="path" />
                  </v-col>
                  <v-col cols="12" md="1" class="pr-0" v-if="!IpadProSize">
                    <CartPopover class="mt-3" v-if="path" />
                  </v-col>
                  <!-- <v-col cols="12" md="1" v-if="Notification_on_off && statusLogin === false">
                  <Notification  class="hidden-sm-and-down  mt-3 "/>
                </v-col> -->
                  <v-col cols="12" md="1" v-if="Notification_on_off && statusLogin === true">
                    <Notification class="hidden-sm-and-down  mt-3 pl-2" />
                  </v-col>
                  <v-col cols="12" md="10" justify="start" class="pl-4">
                    <v-row no-gutters class="mt-1">
                      <v-row dense v-if="statusLogin === false && !IpadProSize" class="mt-3">
                        <!-- <v-tooltip bottom color="rgba(255, 255, 255, .0)" v-if="checkButton === false">
                       <template v-slot:activator="{ on }">
                         <v-btn text style="font-size: 16px; line-height: 24px; color: #333333;" color="white"  v-on="on"  @click="gotoSeller()" :to="registerpath">ขายสินค้า</v-btn>
                       </template>
                        <v-img src="@/assets/ImageINET-Marketplace/ICONRegister/Store.png" contain width="511" height="119" style="margin-left: -28%; margin-top: -18px;"></v-img>
                      </v-tooltip> -->
                        <!-- <v-btn text class="mt-0" color="white"  @click="gotoSeller()" v-else>ขายสินค้า</v-btn> -->
                        <Login v-if="statusLogin === false && !IpadSize" class="mt-0" />
                        <LoginSuccess class="mt-0 ml-2" v-else />
                      </v-row>
                      <v-row dense v-else-if="statusLogin === false && IpadProSize" class="mt-3">
                        <!-- <v-tooltip bottom color="rgba(255, 255, 255, .0)" v-if="checkButton === false">
                       <template v-slot:activator="{ on }">
                         <v-btn text style="font-size: 16px; line-height: 24px; color: #333333;" color="white"  v-on="on" @mousedown.left="linkLoginandRegister('UPS/Register')" @click="gotoSeller()" :to="registerpath">ขายสินค้า</v-btn>
                       </template>
                        <v-img src="@/assets/ImageINET-Marketplace/ICONRegister/Store.png" contain width="511" height="119" style="margin-left: -28%; margin-top: -18px;"></v-img>
                      </v-tooltip> -->
                        <!-- <v-btn text class="mt-4" color="white"  v-on="on" @click="gotoSeller()" v-else>ขายสินค้า</v-btn> -->
                        <Login v-if="statusLogin === false && !IpadSize" class="mt-0" />
                        <LoginSuccess class="mt-0 ml-2" v-else />
                        <!-- <v-btn text style="font-size: 16px; line-height: 24px; color: #333333;"  @mousedown.left="linkLoginandRegister('UPS/Register')" @mousedown.right="linkLoginandRegisterRightClick('UPS/Register')" :to="registerpath">สมัครสมาชิก</v-btn> -->
                        <!-- <span style="border: 2px solid #636363;"></span> -->
                        <!-- <v-divider vertical style="color: #636363;"></v-divider>
                      <v-btn text style="font-weight: bold; font-size: 16px; line-height: 24px; color: #333333;" @click="linkLoginandRegister('UPS/Login')" @mousedown.right="linkLoginandRegisterRightClick('UPS/Login')" :to="loginpath">เข้าสู่ระบบ</v-btn> -->
                      </v-row>
                      <div v-else>
                        <LoginSuccess class="mt-0 ml-2" />
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-toolbar-title>
        </v-col>
      </v-row>

    </v-app-bar>
    <!-- v-navigation-drawer -->
    <v-navigation-drawer v-model='drawer' app left temporary prominent :clipped="$vuetify.breakpoint.mdandDown"
      style="width: 327px; height: 100%;">
      <v-list>
        <v-list-item style="background-color:#52BBAF">
          <v-img v-lazyload :src="require('@/assets/MarketLogo.png')" contain max-height="50"
            style="cursor: pointer; float: right;" @click="goHome()" />
          <v-spacer></v-spacer>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="px-6" style="margin-Top:10px">
          <span class="hidden-md-and-up" text style="font-size: 18px; line-height: 24px; color: #333333;"
            @click="gotoSeller()" :to="registerpath">
            <v-icon color="#27AB9C" size="28" class="mr-2">mdi-cart</v-icon>ขายสินค้า
          </span>
          <!-- <span style="color: #333333; font-size: 16px; line-height: 24px;" class="mr-4"><v-icon color="#00B500" size="22" class="mr-2">mdi-phone</v-icon>โทร 02-591-4005</span> -->
        </v-list-item>
        <!-- <v-list-item class="px-6">
         <span style="color: #333333; font-size: 16px; line-height: 24px;" class="mr-4"><v-icon color="#27AB9C" size="22" class="mr-2">mdi-clock</v-icon>จันทร์- ศุกร์ เวลา 08.00-17.00 น. <br/><span class="pl-8">หยุด เสาร์ อาทิตย์</span></span>
        </v-list-item>
        <v-list-item class="px-6">
          <span style="color: #333333; font-size: 16px; line-height: 24px;"><v-icon color="#27AB9C" size="22" class="mr-2">mdi-email</v-icon>data@ultimateplus.co.th</span>
        </v-list-item>
        <v-list-item class="px-6">
          <img src="@/assets/Line_icon.png" height="22" width="24" class="mr-3" @click="gotoLink('Line')" style="cursor: pointer;"/>
          <v-icon color="#4A7AFF" size="24" @click="gotoLink('Facebook')" style="cursor: pointer;" class="mr-3">mdi-facebook</v-icon>
          <img src="@/assets/instagram_icon.png" height="22" width="22" class="mr-3" @click="gotoLink('Instagram')" style="cursor: pointer;"/>
          <v-icon color="#FF0000" size="24" class="mr-4" @click="gotoLink('Youtube')" style="cursor: pointer;">mdi-youtube</v-icon>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>
    <v-dialog v-model="modalLogin" width="343">
      <v-card>
        <v-card-title>
          <!-- ปุ่มเข้าสู่ระบบ -->
          <v-col cols="12" md="12" sm="12">
            <v-btn block rounded color="#27AB9C" dark elevation="6" style="border-radius: 32px;"
              @click="gotoRegisterMobile()">สมัครสมาชิก</v-btn>
          </v-col>
          <!-- แถบ เข้าสู่ระบบด้วย -->
          <v-row dense justify="center" align-content="center" class="mt-6 mb-6">
            <v-divider style="margin-top: 10px;" class="mx-2"></v-divider>
            <span style="font-size: 14px; line-height: 22px; color: #000000;">หรือ</span>
            <v-divider style="margin-top: 10px;" class="mx-2"></v-divider>
          </v-row>
          <!-- ปุ่มเข้าสู่ระบบแบบ ONE ID -->
          <v-col cols="12" md="12" sm="12">
            <v-btn @click="gotoLoginMobile()" color="#27AB9C" block outlined rounded elevation="4"
              style="border: 1px solid #27AB9C; border-radius: 32px;">เข้าสู่ระบบ</v-btn>
          </v-col>
        </v-card-title>
      </v-card>
    </v-dialog>
    <!-- </v-app> -->
  </div>
</template>
<script>
import { Decode } from '@/services'
export default {
  components: {
    CartPopover: () => import('@/components/PopOver/PopoverCartAppBarUI'),
    Login: () => import('@/components/PopOver/LoginUI'),
    LoginSuccess: () => import('@/components/PopOver/LoginSuccessUI'),
    Notification: () => import('@/components/Notification/Notification')
  },
  data: () => ({
    select_lish_category: '',
    lish_Category: [],
    autosearch: [],
    drawer: false,
    searchtext: '',
    selectedItem: '',
    selectItemCategory: '',
    selectItemBrand: '',
    selectItemIndustry: '',
    menu: '',
    Notification_on_off: true,
    header: '',
    // itemsEatalog: [
    //   { id: '1', image: 'catalog.png', text: 'https://panit.sdi.inet.co.th/backend/ups_catalog/Ultimate%20Plus%20Supply%20-%20PPE%20Catalog_compressed_recommended.pdf', icon: '', subtext: '' }
    // ],
    // items: [
    //   { key: 1, icon: 'mdi-home', color: 'white', title: 'หน้าหลัก', path: 'UPS' },
    //   { key: 2, icon: 'mdi-information', color: 'white', title: 'เกี่ยวกับเรา', path: 'UPS/AboutUs' },
    //   { key: 3, icon: 'mdi-manjaro', color: 'white', title: 'สินค้า' },
    //   { key: 4, icon: 'mdi-professional-hexagon', color: 'white', title: 'โปรโมชัน', path: 'UPS/allpromotion' },
    //   { key: 5, icon: 'mdi-basket', color: 'white', title: 'E-Catalog', path: 'UPS/E-Catalog' },
    //   { key: 6, icon: 'mdi-currency-usd', color: 'white', title: 'วิธีการชำระเงิน', path: 'UPS/Payment' },
    //   { key: 7, icon: 'mdi-ticket', color: 'white', title: 'ข่าวและกิจกรรม', path: 'UPS/News&Activity' },
    //   { key: 8, icon: 'mdi-file-document-edit', color: 'white', title: 'ติดต่อเรา', path: 'UPS/Contact' }
    // ],
    listItemCategory: [],
    listItemBrand: [],
    listItemIndrustry: [],
    countCart: 1,
    statusLogin: false,
    onedata: [],
    ListCategory: [],
    path: false,
    modalLogin: false,
    pathServe: process.env.VUE_APP_DOMAIN,
    loginpath: '',
    registerpath: '',
    appbarPath: '',
    listproductPath: '',
    pathHome: '/',
    toggle_exclusive: null,
    IDCategory: '',
    lish_SubCategory: [],
    select_lish_subcategory: '',
    res: [],
    datas: [],
    selected: []
  }),
  created () {
    this.$forceUpdate()
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => {
        caches.delete(cacheName)
      })
    })
    if (localStorage.getItem('oneData') === undefined) {
      localStorage.removeItem('oneData')
    }
    // this.GetCategory()
    this.getPath()
    if (Object.prototype.hasOwnProperty.call(localStorage, 'oneData')) {
      this.checkButton = true
      this.onedata = []
      this.onedata = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
      // console.log(this.onedata)
      if (this.onedata.user === undefined && this.onedata.user === '') {
        localStorage.removeItem('oneData')
      }
      if (this.onedata.user !== undefined) {
        // this.username = onedata.user[0].first_name_th + ' ' + onedata.user[0].last_name_th
        this.statusLogin = true
        // this.AuthorityUser()
      } else {
        this.statusLogin = false
      }
    } else {
      this.statusLogin = false
      this.checkButton = false
    }
    // window.addEventListener('storage', function (event) {
    //   if (Object.prototype.hasOwnProperty.call(localStorage, 'oneData')) {
    //     window.location.reload()
    //   }
    // })
  },
  mounted () {
    // this.AuthorityUser()
    this.$EventBus.$on('searchdata', this.searchdata)
    this.$EventBus.$on('getPath', this.getPath)
    this.$on('hook:beforeDestroy', () => {
      this.$EventBus.$off('searchdata')
      this.$EventBus.$off('getPath')
    })
  },
  computed: {
    // main () {
    //   return this.$route.name === 'Home'
    // },
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  methods: {
    // async AuthorityUser () {
    //   await this.$store.dispatch('actionsAuthorityUser')
    //   var response = await this.$store.state.ModuleUser.stateAuthorityUser
    //   console.log('Authority', response.data.current_role_user)
    // },
    gotoSeller () {
      if (Object.prototype.hasOwnProperty.call(localStorage, 'oneData')) {
        if (this.onedata.user.type_user === 'oneID_user') {
          this.$router.push({ path: '/seller' }).catch(() => {})
        } else {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาผูกบัญชีกับ One ID ก่อน!', showConfirmButton: false, timer: 1500 })
        }
      } else {
        this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบหรือสมัครสมาชิกก่อน!', showConfirmButton: false, timer: 1500 })
        this.$EventBus.$emit('openModalLogin')
      }
    },
    async getPath () {
      var currentRoutepath = this.$router.currentRoute.path
      // console.log('getPath', currentRoutepath)
      if (currentRoutepath === '/shoppingcart' || currentRoutepath === '/checkout') {
        this.path = false
      } else {
        this.path = true
      }
    },
    async GetCategory () {
      await this.$store.dispatch('GetDefaultCagegory')
      this.ListCategory = await this.$store.state.ModuleManageShop.Category
      // console.log('ListCategory', this.ListCategory)
    },
    goHome () {
      if (Object.prototype.hasOwnProperty.call(localStorage, 'oneData')) {
        if (this.onedata.user !== undefined) {
          if (localStorage.getItem('roleUserApprove') !== null) {
            // console.log('เข้าเงื่อนไขขขขขขขขข')
            var val = JSON.parse(localStorage.getItem('roleUser'))
            var data = {
              role: val.role === 'purchaser' ? 'purchaser' : 'ext_buyer'
            }
            val.role === 'ext_buyer' ? this.changeRole = 'ext_buyer' : this.changeRole = 'purchaser'
            localStorage.setItem('roleUser', JSON.stringify(data))
            this.$EventBus.$emit('LinkPage', val.role)
            this.searchtext = ''
            this.$router.push({ path: '/' }).catch(() => {})
          }
          this.searchtext = ''
          this.$router.push({ path: '/' }).catch(() => {})
        } else {
          localStorage.removeItem('oneData')
          this.$router.push({ path: '/' }).catch(() => {})
        }
      } else {
        this.searchtext = ''
        this.$router.push({ path: '/' }).catch(() => {})
      }
    },
    gotoCreateEpro () {
      this.$router.push({ path: '/createbusinesssid' }).catch(() => {})
    },
    gotoLoginMobile () {
      this.modalLogin = false
      this.$router.push({ path: '/Login' })
    },
    gotoRegisterMobile () {
      this.modalLogin = false
      this.$router.push({ path: '/Register' })
    },
    searchdata () {
      // console.log('BBBBBB')
      if (this.searchtext === '') {
        this.$swal.fire({
          icon: 'warning',
          title: 'โปรดใส่คำที่จะค้นหา',
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        // localStorage.setItem('searchtext', this.searchtext)
        if (this.$router.currentRoute.name === 'search') {
          if (this.$router.currentRoute.params.data === this.searchtext) {
            // console.log('condition 1')
            this.$EventBus.$emit('getResultSearch')
          } else {
            // console.log('condition 2')
            this.$router.push({ path: `${encodeURIComponent(this.searchtext)}` }).catch(() => {})
            this.$EventBus.$emit('getResultSearch')
          }
        } else {
          // console.log('condition 3')
          this.$router.push({ path: `/search/${encodeURIComponent(this.searchtext)}` }).catch(() => {})
          // this.$router.push({ path: `/DetailProduct/${this.searchtext}` }).catch(() => {})
          this.$EventBus.$emit('getResultSearch')
        }
      }
    }
  }
}
</script>

<style lang="css" scoped>
.bg-color {
  background-color: #27AB9C !important
}
.textSearch {
  /* max-height: 25px;
  max-width: 100%;
  border: 1px solid #E6E6E6;
  box-sizing: border-box;
  border-radius: 6px; */
  font-size: 16px;
  margin-left: 4px;
  /* padding: 0px 8px 2px !important;
  text-decoration: none !important; */
}
/* .textSearch >>> .v-input__slot::before {
  border-style: none !important;
}
.textSearchIpad >>> .v-input__slot::before {
  border-style: none !important;
} */
.textSearchIpad {
  /* max-height: 25px;
  max-width: 100%;
  border: 1px solid #E6E6E6;
  box-sizing: border-box;
  padding: 0px 8px 2px !important;
  text-decoration: none !important;
  border-radius: 6px; */
  font-size: 16px;
  margin-left: 4px;
}
.instagram{
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%);
}
@media screen and (min-width: 768px) {
  .responsive_menu {
    margin-left: 2.5%;
  }
  .appBarResponsive {
    margin-left: 5%;
  }
}
@media screen and (min-width: 900px) and (max-width: 1280px) {
  .responsive_menu {
    margin-left: 2.2%;
  }
  .appBarResponsive {
    margin-left: 2%;
  }
}
@media screen and (min-width: 1280px) and (max-width: 1600px) {
  .responsive_menu {
    margin-left: 5.2%;
  }
  .appBarResponsive {
    margin-left: 6%;
  }
}
@media screen and (min-width: 1600px) {
  .responsive_menu {
    margin-left: 7.7%;
  }
  .appBarResponsive {
    margin-left: 7.4%;
  }
}
@media only screen and (min-width: 640px) {
  .responsive_navbar_2 {
    display: none !important;
  }
}
@media only screen and (max-width: 640px) {
  .responsive_navbar {
    display: none !important;
  }
  .Setting_down {
    display: none;
  }
  .shopping-cart-logo {
    display: none;
  }
  .profile_name {
    display: none;
  }
  /* .e-pro-front {
    display: none;
  } */
  .e-pro-back {
    display: flex;
  }
  .vdivider {
    display: none;
  }
  .logo-login-pass {
    display: none;
  }
  .logo-login-pass-mobile {
    display: flex;
  }
}
/* For Responsive mobile, Ipad, Website */
@media screen and (min-width: 360px) {
  .displayMobile {
    display: inline;
  }
  .displayIPAD {
    display: none;
  }
  .diaplayWeb {
    display: none;
  }
}
@media screen and (min-width: 768px) and (max-width: 1280px) {
  .displayIPAD {
    display: inline;
  }
  .displayMobile {
    display: none;
  }
  .diaplayWeb {
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  .displayIPAD {
    display: none;
  }
  .displayMobile {
    display: none;
  }
  .diaplayWeb {
    display: inline;
  }
}
</style>
